// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"aS-z","inlineTitle":"bS-z","sponsoredAdsWrapper":"cS-z","marketplaceRecosWrapper":"dS-z"};